import { MessagePlatform } from '../../../../../__generated__/globalTypes'
import { ButtonFields_action } from '../../__generated__/ButtonFields'

export function findMessagePlatform(
  buttonAction: ButtonFields_action | null
): MessagePlatform | undefined {
  if (buttonAction?.__typename !== 'LinkAction') return undefined

  const link = buttonAction.url
  if (link == null) return undefined
  const platform = messagePlatforms.find(({ url }) => link.includes(url))

  return platform?.messagePlatform
}

export const messagePlatforms = [
  {
    url: 'm.me/',
    messagePlatform: MessagePlatform.facebook
  },
  {
    url: 'messenger.com/',
    messagePlatform: MessagePlatform.facebook
  },
  {
    url: 'fb.me/',
    messagePlatform: MessagePlatform.facebook
  },
  {
    url: 't.me/',
    messagePlatform: MessagePlatform.telegram
  },
  {
    url: 'telegram.org/',
    messagePlatform: MessagePlatform.telegram
  },
  {
    url: 'wa.me/',
    messagePlatform: MessagePlatform.whatsApp
  },
  {
    url: 'whatsapp://',
    messagePlatform: MessagePlatform.whatsApp
  },
  {
    url: 'api.whatsapp.com/',
    messagePlatform: MessagePlatform.whatsApp
  },
  {
    url: 'instagram.com/',
    messagePlatform: MessagePlatform.instagram
  },
  {
    url: 'viber://',
    messagePlatform: MessagePlatform.viber
  },
  {
    url: 'vb.me',
    messagePlatform: MessagePlatform.viber
  },
  {
    url: 'viber.me/',
    messagePlatform: MessagePlatform.viber
  },
  {
    url: 'vk://',
    messagePlatform: MessagePlatform.vk
  },
  {
    url: 'vk.com/',
    messagePlatform: MessagePlatform.vk
  },
  {
    url: 'snapchat.com/',
    messagePlatform: MessagePlatform.snapchat
  },
  {
    url: 'skype',
    messagePlatform: MessagePlatform.skype
  },
  {
    url: 'line://',
    messagePlatform: MessagePlatform.line
  },
  {
    url: 'line.me',
    messagePlatform: MessagePlatform.line
  },
  {
    url: 'tiktok.com/@',
    messagePlatform: MessagePlatform.tikTok
  },
  {
    url: 'discord.gg/',
    messagePlatform: MessagePlatform.discord
  },
  {
    url: 'discord.com/invite/',
    messagePlatform: MessagePlatform.discord
  },
  {
    url: 'discord.com/users/',
    messagePlatform: MessagePlatform.discord
  },
  {
    url: 'discord.com/channels/',
    messagePlatform: MessagePlatform.discord
  },
  {
    url: 'discord://',
    messagePlatform: MessagePlatform.discord
  },
  {
    url: 'signal.me/',
    messagePlatform: MessagePlatform.signal
  },
  {
    url: 'signal.group/',
    messagePlatform: MessagePlatform.signal
  },
  {
    url: 'sgnl://',
    messagePlatform: MessagePlatform.signal
  },
  {
    url: 'weixin://',
    messagePlatform: MessagePlatform.weChat
  },
  {
    url: 'u.wechat.com/',
    messagePlatform: MessagePlatform.weChat
  }
]
